module.exports = __webpack_public_path__ + "img/social.7d1eff90.png";